/** @jsxImportSource @emotion/react */

import { Checkbox } from "@a_team/ui-components";
import _ from "lodash";

export interface CollaboratorTableCellOptionProps {
  style?: any;
  name: string;
  userIsAdmin: boolean;
  userId: string;
  settings: any;
  onChange: any;
  disabled?: boolean;
}

export const TableCellOption = (props: CollaboratorTableCellOptionProps) => {
  const attr = _.camelCase(props.name);
  return (
    <div css={props.style}>
      <Checkbox
        data-user-id={props.userId}
        data-attr={attr}
        checked={props.settings?.[attr]}
        onChange={props.onChange}
        disabled={props.disabled}
      />
    </div>
  );
};
